import types from './actionTypes'
import { union, filter } from 'lodash'

const initialState = {
  markedCode: []
}

export default function auth(state = initialState, action) {
  switch (action.type) {
    case types.SHARED_MARK_CODE:
      return {
        ...state,
        markedCode: union(state.markedCode, [action.data])
      }
    case types.SHARED_UNMARK_CODE:
      return {
        ...state,
        markedCode: filter(state.markedCode, obj => obj !== action.data)
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/shared/reducers.js